export const referrals = {
  menu: {
    label: "Polecaj i zarabiaj",
    badge: "Zarabiaj",
  },
  welcomeCard: {
    title: "Plan może być darmowy",
    desc: "Zapraszając innych gospodarzy, otrzymuje Pan/Pani udział we wszystkim, co zapłacą, na zawsze.",
  },
  page: {
    loading: "Wczytywanie poleceń…",
    previewNotice: "Podgląd na danych przykładowych. Prawdziwe polecenia pojawią się tutaj po uruchomieniu programu.",
  },
  hero: {
    title: "Zaproś innych gospodarzy i korzystaj z WACheckin za darmo",
    subtitle: "Za każdego gospodarza, który wykupi subskrypcję z tego linku, przysługuje {percent}% wszystkiego, co zapłaci, co miesiąc i na zawsze. Zaproszona osoba zaczyna z rabatem {friendPercent}%.",
    personal: "Plan kosztuje {price} miesięcznie. Liczba poleceń, która wystarczy, aby nie płacić już nigdy: {count}.",
    personalGeneric: "Liczba płacących gospodarzy, przy której plan staje się darmowy: {count}.",
  },
  rewards: {
    youGet: "Dla Pana/Pani",
    youGetBig: "{percent}% z każdej płatności",
    youGetSmall: "od każdego zaproszonego gospodarza, co miesiąc i na zawsze",
    friendGets: "Dla zaproszonej osoby",
    friendGetsBig: "{percent}% rabatu",
    friendGetsSmall: "przez pierwsze {months} miesiące",
    example: "Gospodarz z liczbą apartamentów {units} to zarobek około {amount} rocznie, tak długo, jak pozostaje klientem.",
  },
  welcomeOffer: {
    title: "Prezent powitalny",
    text: "Zaproszenie do WACheckin od: {name}. Przysługuje {percent}% rabatu przez pierwsze {months} miesiące. Rabat jest naliczany przy wykupieniu subskrypcji.",
  },
  share: {
    title: "Link z zaproszeniem",
    codeLabel: "Kod",
    copy: "Kopiuj link",
    copied: "Skopiowano",
    whatsapp: "WhatsApp",
    invite: "Wyślij e-mailem",
    more: "Więcej",
    message: "Polecam WACheckin: korzystam z niego przy check-inie online, wiadomościach do gości oraz połączeniu Booking i Airbnb, i oszczędza mi mnóstwo czasu. Z tym linkiem można otrzymać {percent}% rabatu przez pierwsze {months} miesiące: {link}",
    emailSubject: "{percent}% rabatu na WACheckin z moim linkiem",
  },
  invite: {
    title: "Zaproś e-mailem",
    subtitle: "Do znajomej osoby zostanie wysłane osobiste zaproszenie z linkiem i rabatem {percent}%.",
    emailLabel: "E-mail znajomej osoby",
    emailPlaceholder: "imie@firma.com",
    languageLabel: "Język wiadomości",
    cancel: "Anuluj",
    send: "Wyślij zaproszenie",
    sending: "Wysyłanie…",
    successTitle: "Zaproszenie wysłane!",
    successDesc: "Zaproszenie zostało wysłane na adres {email}.",
    another: "Zaproś kolejną osobę",
    close: "Zamknij",
    errors: {
      invalidEmail: "Proszę podać prawidłowy adres e-mail.",
      selfInvite: "Nie można wysłać zaproszenia na własny adres e-mail.",
      alreadyInvited: "Ten adres był już niedawno zapraszany. Ponowna próba będzie możliwa za kilka dni.",
      dailyLimit: "Osiągnięto dzisiejszy limit zaproszeń. Proszę spróbować jutro.",
      tooFast: "Zbyt wiele prób pod rząd. Proszę odczekać minutę i spróbować ponownie.",
      generic: "Nie udało się wysłać zaproszenia. Proszę spróbować ponownie.",
    },
  },
  message: {
    title: "Gotowa wiadomość do udostępnienia",
    hint: "Można ją wkleić w grupach gospodarzy, na forach lub w mediach społecznościowych. Najlepiej działa z jednym zdaniem od siebie.",
    copy: "Kopiuj wiadomość",
  },
  how: {
    title: "Jak to działa",
    stepLabel: "Krok {n}",
    step1Title: "Udostępnienie linku",
    step1Desc: "Przez WhatsApp, e-mail albo w grupach gospodarzy.",
    step2Title: "Subskrypcja z rabatem",
    step2Desc: "Zaproszona osoba rejestruje się z tym linkiem i zaczyna z rabatem {percent}%.",
    step3Title: "Zarobek co miesiąc",
    step3Desc: "{percent}% z każdej płatności trafia na saldo, na zawsze. Pierwsza płatność liczy się po {days} dniach.",
  },
  results: {
    title: "Wyniki",
    celebrate: "Dotychczasowy zarobek: {amount}.",
    coverage: "Polecenia pokrywają już {percent}% planu",
    coverageFree: "Plan jest już darmowy",
    coverageHint: "Plan kosztuje {price} miesięcznie, a polecenia przynoszą {earning} miesięcznie.",
  },
  stats: {
    invited: "Zaproszeni",
    subscribed: "Płacący",
    monthlyEarning: "Zarobek miesięczny",
    creditAvailable: "Dostępne saldo",
    creditEarned: "Łącznie zarobiono: {amount}",
    creditHint: "Odliczane automatycznie od następnej faktury",
  },
  list: {
    title: "Polecone osoby",
    colName: "Konto",
    colDate: "Rejestracja",
    colStatus: "Status",
    colReward: "Zarobek",
    empty: "Nie zaproszono jeszcze nikogo. Pierwszy gospodarz, który wykupi subskrypcję z tego linku, zacznie przynosić saldo co miesiąc.",
  },
  status: {
    registered: "Zarejestrowany",
    subscribed: "Płacący",
    rewarded: "Przynosi zarobek",
    canceled: "Anulowany",
    rejected: "Niekwalifikujący się",
  },
  reward: {
    waiting: "Oczekiwanie na pierwszą płatność",
    startsOn: "Początek zarobku: {date}",
    earning: "{monthly} miesięcznie, łącznie {earned}",
    earningNoPlan: "Łącznie {earned}",
    canceled: "Zarobiono {earned}",
  },
  reasons: {
    duplicate: "Zduplikowane konto",
    selfReferral: "Polecenie samego siebie",
  },
  faq: {
    title: "Najczęstsze pytania",
    howMuchQ: "Ile wynosi zarobek?",
    howMuchA: "{percent}% wszystkiego, co płaci każdy zaproszony gospodarz (bez podatku), co miesiąc i na zawsze, bez limitu poleceń. Jeśli płaci {price} miesięcznie, zarobek wynosi około {amount} w każdym miesiącu.",
    whenQ: "Kiedy następuje naliczenie?",
    whenA: "Za każdym razem, gdy polecona osoba zapłaci, kwota trafia automatycznie na saldo. Jej pierwsza płatność liczy się po {days} dniach, na wypadek anulowania zaraz po wykupieniu subskrypcji.",
    whereQ: "Gdzie wykorzystywane jest saldo?",
    whereA: "Jest odliczane automatycznie od kolejnych faktur WACheckin. W razie braku subskrypcji zostanie zastosowane na pierwszej fakturze.",
    limitQ: "Czy istnieje limit?",
    limitA: "Nie ma limitu poleceń ani czasu. Jedyny limit: zgromadzone i niewykorzystane saldo sięga {months} miesięcy planu. Do tego pułapu plan pozostaje darmowy, a nadwyżka nie jest zapisywana.",
    stopQ: "Kiedy kończy się zarobek?",
    stopA: "Jeśli polecona osoba anuluje subskrypcję, zarobek z jej tytułu ustaje. W razie anulowania własnej subskrypcji saldo przestaje się gromadzić.",
    whoQ: "Kogo można zaprosić?",
    whoA: "Każdego gospodarza lub hotel, który jeszcze nie korzysta z WACheckin. Polecenia samego siebie i zduplikowane konta nie kwalifikują się.",
  },
};
